import React, {memo, useCallback, useMemo, useRef, useState} from "react"
import {useSelector} from "react-redux"
import arrowIcon from "../../../assets/images/icons/footer/arrow-top.png"
import {onClickHandler} from "../../../utils/onclick"
import {PhaseModel} from "../types/types"
import {PhaseComponent} from "./PhaseComponent"

type Raw = {
    selected: boolean
    id: string
}
type Props<T = Raw> = {
    onClickPhaseChanging: (id: string) => void
    onClickAllPhase?: () => void
    selectedPhase: T
}
export const PhaseField = memo(function PhaseField({onClickPhaseChanging, onClickAllPhase, selectedPhase}: Props) {
    const sliderRef = useRef<any>(null)
    const screenWidth = window.innerWidth
    const [sliderRefValue, setSliderRefValue] = useState(0)
    const controls = useSelector(state => state.control.controlList)
    const controlList = controls.filter(control => control.type_id === "200")
    const onClickNextPhase = useCallback(() => {
        setSliderRefValue((sliderRef.current.scrollLeft += 300))
        return (sliderRef.current.scrollLeft += 300)
    }, [])
    const onClickPrevPhase = useCallback(() => {
        setSliderRefValue((sliderRef.current.scrollLeft -= 300))
        return (sliderRef.current.scrollLeft -= 300)
    }, [])
    const Phases: PhaseModel[] = useMemo(() => controlList, [controlList])

    const screenQuery = useCallback(
        (action: string, onClick: () => void) => {
            return (
                <div
                    className={`energy-slider-icon-container ${action} ${
                        screenWidth >= 1024
                            ? Phases.length < 7
                                ? "_arrow-hide"
                                : ""
                            : screenWidth <= 600
                            ? Phases.length < 4
                                ? "_arrow-hide"
                                : ""
                            : ""
                    }`}
                    onClick={onClick}
                >
                    <img src={arrowIcon} alt="" />
                </div>
            )
        },
        [screenWidth, Phases]
    )
    return (
        <div className="energy-phase-menu-container">
            {screenQuery("_prev", onClickPrevPhase)}
            <span ref={sliderRef}>
               {/*<button
                    className={`${!selectedPhase.selected ? "energy-active-button" : ""}`}
                    {...onClickHandler(onClickAllPhase)}
                >
                    Tümü
    </button>*/}
                {Phases.map(phase => (
                    <PhaseComponent
                        key={phase.id}
                        id={phase.id}
                        name={phase.name}
                        is_selected={(selectedPhase.id === phase.id && selectedPhase.selected) || false}
                        {...onClickHandler(() => onClickPhaseChanging(phase.id))}
                    />
                ))}
            </span>
            {screenQuery("_next", onClickNextPhase)}
        </div>
    )
})
